<template>
  <div>
    <v-divider></v-divider>
    <div class="profile-detail pa-1">
      <div>
        <v-avatar>
          <!-- src="https://firebasestorage.googleapis.com/v0/b/choche-wees.appspot.com/o/perfil%2Fperfil.jpg?alt=media&token=737981fd-8ebb-4c76-aeea-a1de76f766cf" -->
          <img src="@/assets/logo.png" alt="Choche Wees" />
        </v-avatar>
        <span>&copy; 2021 José Luis Morales Bataz (Choche wees)</span>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // project: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.profile-detail {
  max-width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.text-container {
  max-width: 1200px;
}
</style>
